/**
 * Copies text to the clipboard, returning whether it succeeded.
 *
 * Prefers the async Clipboard API and falls back to a hidden-textarea `execCommand("copy")`
 * for environments where the modern API is unavailable or blocked.
 */
export async function copyTextToClipboard(text: string): Promise<boolean> {
    if (text === "") {
        return false
    }

    try {
        if (typeof navigator !== "undefined" && navigator.clipboard?.writeText) {
            await navigator.clipboard.writeText(text)
            return true
        }
    } catch {
        // Fall through to the legacy path below.
    }

    try {
        if (typeof document === "undefined") {
            return false
        }

        const textarea = document.createElement("textarea")
        textarea.value = text
        textarea.setAttribute("readonly", "true")
        textarea.style.position = "fixed"
        textarea.style.left = "-9999px"
        textarea.style.top = "0"

        document.body.appendChild(textarea)
        textarea.focus()
        textarea.select()
        const success = document.execCommand("copy")
        document.body.removeChild(textarea)
        return success
    } catch {
        return false
    }
}
